import posthog from "posthog-js";

import { analyticsEnabled } from "./enabled";
import { registerEnvironmentSuperProperty } from "./register-environment";

/**
 * PostHog init — import as early as possible (see index.jsx).
 * Skipped when analyticsEnabled is false so local bugs can't flood the project.
 */
if (analyticsEnabled) {
    posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN, {
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        // SPA navigations won't fire $pageview without history_change.
        capture_pageview: "history_change",
        // Manual events only for now — autocapture is too noisy.
        autocapture: false,
    });

    registerEnvironmentSuperProperty();
}
